import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, ShoppingCartIcon } from '@heroicons/react/24/outline';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-gray-100">
      <main className="pb-16">
        {children}
      </main>
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200">
        <div className="flex justify-around items-center h-16">
          <Link
            to="/"
            className={`flex flex-col items-center justify-center w-1/2 ${
              location.pathname === '/' ? 'text-blue-500' : 'text-gray-500'
            }`}
          >
            <HomeIcon className="h-6 w-6" />
            <span className="text-xs mt-1">Temperature</span>
          </Link>
          <Link
            to="/shopping"
            className={`flex flex-col items-center justify-center w-1/2 ${
              location.pathname === '/shopping' ? 'text-blue-500' : 'text-gray-500'
            }`}
          >
            <ShoppingCartIcon className="h-6 w-6" />
            <span className="text-xs mt-1">Shopping</span>
          </Link>
        </div>
      </nav>
    </div>
  );
};

export default Layout; 